(() => {
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const Tools = customElements.get('zayix-browsing-tools');
  if (!Tools || Tools.prototype.setupScope) return;
  Tools.prototype.setupScope = function () {
    this.form = this.querySelector('form');
    this.input = this.form.querySelector('input[name="q"]');
    this.scopeButton = this.querySelector('[data-remove-scope]');
    this.scoped = true;
    this.query = new URL(location.href).searchParams.get('collection_q') || '';
    this.input.value = this.query;
    this.scopeButton.addEventListener('click', () => {
      this.scoped = false;
      this.scopeButton.hidden = true;
      this.input.placeholder = this.dataset.globalPlaceholder;
      if (this.input.value.trim()) {
        const url = new URL(this.form.action);
        url.searchParams.set('q', this.input.value.trim());
        url.searchParams.set('type', 'product');
        location.assign(url);
      }
    }, { signal: this.controller.signal });
    this.form.addEventListener('submit', event => {
      if (!this.scoped) return;
      event.preventDefault();
      const query = this.input.value.trim();
      if (!query) { location.assign(this.dataset.collectionUrl); return; }
      const url = new URL(this.dataset.collectionUrl, location.origin);
      url.searchParams.set('collection_q', query);
      history.pushState({ collection_q: query }, '', url);
      this.runScopedSearch(query);
    }, { signal: this.controller.signal });
    window.addEventListener('popstate', () => {
      if ((new URL(location.href).searchParams.get('collection_q') || '') !== this.query) location.reload();
    }, { signal: this.controller.signal });
    if (this.query) this.runScopedSearch(this.query);
  };
  Tools.prototype.fetchText = async function (url, signal) {
    const response = await fetch(url, { signal });
    if (!response.ok) throw new Error('Unable to load collection');
    return response.text();
  };
  Tools.prototype.runScopedSearch = async function (query) {
    this.searchController?.abort();
    this.searchObserver?.disconnect();
    const controller = new AbortController();
    this.searchController = controller;
    const { signal } = controller;
    this.query = query;
    const container = document.getElementById('ProductGridContainer');
    const original = container?.querySelector('#product-grid');
    if (!container || !original) return;
    this.gridClass = this.gridClass || original.className;
    const sectionId = original.dataset.id;
    container.querySelector('zayix-collection-scroll')?.remove();
    document.documentElement.style.overflowAnchor = 'none';
    document.documentElement.classList.add('zayix-scoped-active');
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.className = 'zayix-search-status';
    status.textContent = this.dataset.searching;
    const grid = document.createElement('ul');
    grid.id = 'product-grid';
    grid.dataset.id = sectionId;
    grid.className = this.gridClass;
    grid.setAttribute('aria-busy', 'true');
    const controls = document.createElement('div');
    controls.className = 'zayix-search-more';
    const more = document.createElement('button');
    more.type = 'button';
    more.className = 'button button--secondary';
    more.textContent = this.dataset.loadMore;
    more.hidden = true;
    controls.append(more);
    container.replaceChildren(status, grid, controls);
    this.resultGrid = grid;
    this.resultStatus = status;
    this.resultMore = more;
    this.resultControls = controls;
    this.resultLoading = false;
    this.resultOffset = 0;
    this.resultFailed = false;
    more.addEventListener('click', () => { this.resultFailed = false; this.appendSearchResults(); }, { signal });
    container.scrollIntoView({ block: 'start', behavior: 'instant' });
    window.scrollBy(0, -100);
    try {
      if (!this.collectionIndex) {
        const products = [];
        let next = this.dataset.collectionUrl + '?view=zayix-index';
        while (next) {
          const json = JSON.parse(await this.fetchText(next, signal));
          if (!Array.isArray(json.products)) throw new Error('Invalid collection');
          products.push(...json.products);
          next = json.next;
        }
        this.collectionIndex = products;
      }
      if (signal.aborted) return;
      const terms = normalize(query).replace(/["']/g, '').split(/\s+/).filter(Boolean);
      this.matches = this.collectionIndex.filter(product => {
        const text = normalize([product.title, ...(product.tags || []), ...(product.skus || [])].join(' '));
        return terms.every(term => text.includes(term));
      });
      this.resultSummary = this.dataset.results.replace('[count]', String(this.matches.length)).replace('[query]', query);
      status.textContent = this.resultSummary;
      grid.removeAttribute('aria-busy');
      if (!this.matches.length) { status.textContent += ' ' + this.dataset.noResults; return; }
      this.searchObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !this.resultFailed) this.appendSearchResults();
      }, { rootMargin: '600px 0px' });
      await this.appendSearchResults();
    } catch (error) {
      if (error.name !== 'AbortError') { status.textContent = this.dataset.searchError; grid.removeAttribute('aria-busy'); }
    }
  };
  Tools.prototype.appendSearchResults = async function () {
    if (this.resultLoading || this.resultOffset >= this.matches.length) return;
    const signal = this.searchController.signal;
    const grid = this.resultGrid;
    const button = this.resultMore;
    this.resultLoading = true;
    button.disabled = true;
    this.resultStatus.textContent = this.dataset.loading;
    try {
      const batch = this.matches.slice(this.resultOffset, this.resultOffset + 24);
      const rendered = new Array(batch.length);
      let cursor = 0;
      const worker = async () => {
        while (cursor < batch.length) {
          const i = cursor++;
          const base = this.dataset.productRoot + '/' + encodeURIComponent(batch[i].handle);
          const html = new DOMParser().parseFromString(await this.fetchText(base + '?view=zayix-card', signal), 'text/html');
          const card = html.querySelector('li.grid__item');
          if (!card) throw new Error('Missing card');
          rendered[i] = card;
        }
      };
      await Promise.all(Array.from({ length: Math.min(4, batch.length) }, worker));
      if (signal.aborted || !grid.isConnected) return;
      const y = scrollY;
      grid.append(...rendered);
      grid.getBoundingClientRect();
      window.scrollTo({ top: y, behavior: 'instant' });
      this.resultOffset += batch.length;
      this.resultStatus.textContent = this.resultSummary;
      button.hidden = this.resultOffset >= this.matches.length;
      if (!button.hidden) this.searchObserver.observe(this.resultControls);
      else this.searchObserver.disconnect();
    } catch (error) {
      if (error.name !== 'AbortError' && grid.isConnected) {
        this.resultFailed = true;
        this.resultStatus.textContent = this.dataset.searchError;
        button.hidden = false;
        this.searchObserver?.disconnect();
      }
    } finally { if (this.searchController.signal === signal) { this.resultLoading = false; button.disabled = false; } }
  };
  document.querySelectorAll('zayix-browsing-tools').forEach(element => { if (element.controller && !element.form) element.setupScope(); });
})();

